import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ ADDED ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ ADDED ▼▼▼
import './Garden.css';

const GardenEn = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ ADDED ▼▼▼

    // ▼▼▼ ADDED ▼▼▼
    // Function to open the lightbox
    const openLightbox = (imageSrc) => {
        setLightboxImage(imageSrc);
    };

    return (
        // ▼▼▼ Wrapped with Fragment <> ▼▼▼
        <>
            {/* ▼▼▼ ADDED THIS ENTIRE HELMET BLOCK ▼▼▼ */}
            <Helmet>
                <title>A Garden Retreat of Silence | Five Features | Kanazawa Stay Akebono</title>
                <meta name="description" content="Immerse yourself in Kanazawa's rich garden culture at Akebono. Our 330-square-meter private garden offers a tranquil retreat, connecting you with the seasonal beauty of Japan." />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="A Garden Retreat of Silence | Kanazawa Stay Akebono" />
                <meta property="og:description" content="Immerse yourself in Kanazawa's rich garden culture. Our private garden offers a tranquil retreat, connecting you with the seasonal beauty of Japan." />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/feature-garden.jpg" />
            </Helmet>
            {/* ▲▲▲ ADDITION ENDS HERE ▲▲▲ */}

            <div className="akebono-garden-page">

                {/* HERO Section */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/feature-garden.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>A Garden Retreat of Silence</h1>
                    </div>
                </section>

                {/* Section 1: Kanazawa's Garden Culture */}
                <section className="akebono-garden-culture">
                    <h2>What is Kanazawa Garden Culture?</h2>
                    <p>
                        Kanazawa, once the castle town of the prosperous Kaga Domain, has a deep-rooted garden culture alongside tea ceremony and Noh theater.
                    </p>
                    <p>
                        Famous for Kenrokuen, one of Japan’s Three Great Gardens, the city is dotted with tranquil and refined gardens that reflect the spirit of samurai and tea culture.
                    </p>
                    <p>
                        The hospitality found in tea culture is also reflected in garden design. Roji paths, moss gardens, bamboo fountains, and stone wash basins all create a space for contemplation and seasonal appreciation.
                    </p>
                    <p>
                        These gardens are not just for viewing—they are living art, intertwined with daily life.
                    </p>
                    <div className="akebono-garden-gallery">
                        {/* ▼▼▼ ADDED onClick HANDLERS ▼▼▼ */}
                        <img src="/images/kanazawa-garden1.jpg" alt="Kenrokuen in spring" onClick={() => openLightbox('/images/kanazawa-garden1.jpg')} />
                        <img src="/images/kanazawa-garden2.jpg" alt="Kanazawa Castle in winter" onClick={() => openLightbox('/images/kanazawa-garden2.jpg')} />
                        <img src="/images/kanazawa-garden3.jpg" alt="Shofukaku Garden in autumn" onClick={() => openLightbox('/images/kanazawa-garden3.jpg')} />
                    </div>
                </section>

                {/* Section 2: Akebono's Garden */}
                <section className="akebono-garden-feature">
                    <h2>The Garden at Akebono</h2>
                    <p>
                        At Kanazawa Stay Akebono, a 330-square-meter garden stretches through the heart of the house. Mossy stones, seasonal plants, and stepping stones evoke the feeling of a tea garden path.
                        Guests can enjoy views of the garden from every room: cherry blossoms in spring, fresh greens in summer, autumn foliage, and winter snow—all unfolding like a living painting.
                    </p>
                    <div className="akebono-garden-gallery">
                        {/* ▼▼▼ ADDED onClick HANDLERS ▼▼▼ */}
                        <img src="/images/garden1.png" alt="Spring garden" onClick={() => openLightbox('/images/garden1.png')} />
                        <img src="/images/garden2.jpg" alt="Autumn leaves" onClick={() => openLightbox('/images/garden2.jpg')} />
                        <img src="/images/garden3.jpg" alt="Garden view from the room" onClick={() => openLightbox('/images/garden3.jpg')} />
                    </div>
                </section>

                {/* Section 3: Garden Walk Model Course */}
                <section className="akebono-garden-tour">
                    <h2>Garden Walk Around Kanazawa</h2>
                    <p>
                        Kanazawa is home to many diverse gardens beyond Kenrokuen. Here are some you can explore by foot and bus:
                    </p>

                    <div className="garden-card">
                        <img src="/images/spot-terashima.jpg" alt="Terashima Residence" onClick={() => openLightbox('/images/spot-terashima.jpg')} />
                        <div>
                            <h3>Terashima Kurando Residence</h3>
                            <p>A garden reflecting samurai culture. The blooming Enkianthus is stunning in spring.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-gyokusen.jpg" alt="Gyokusen-en" onClick={() => openLightbox('/images/spot-gyokusen.jpg')} />
                        <div>
                            <h3>Gyokusen-en Garden</h3>
                            <p>Features the historic teahouse "Saisetsutei," where guests can experience tea culture.</p>
                        </div>
                    </div>
                    {/* ... Other garden cards remain the same ... */}
                </section>

                {/* Lightbox display */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                         {/* ▼▼▼ CORRECTED LIGHTBOX ▼▼▼ */}
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="Enlarged view" className="lightbox-content" />
                    </div>
                )}

                {/* Section 4: Closing */}
                <section className="akebono-garden-closing">
                    <h2>Time With a Garden, at Your Stay</h2>
                    <p>
                        The gardens of Kanazawa embody aesthetic mindfulness. Akebono extends that experience to your accommodation—offering moments of peace surrounded by seasonal beauty.
                    </p>
                </section>

            </div>
        </> // ▲▲▲ Wrapped with Fragment <> ▲▲▲
    );
};

export default GardenEn;